// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"style__messageBox__og1Fl","contentWrapper":"style__contentWrapper__eZNlj"};